export const Colors = {
  primary: "#42A74B",
};
